/*
 * @Description:抖音待编渠道路由
 * @Author: lzy
 * @LastEditors: pu.yuchun
 * @Date: 19-11-03
 * @LastEditTime: 2019-11-12 19:13:39
 */
"use strict";
angular.module("editBaijiahaoToBeCompiledRouterModule", []).config([
  "$stateProvider",
  "$urlRouterProvider",
  function($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state("front.editctr.baijiahao.waitcompiled", {
        url: "/waitcompiled?account&isOriginal&channelid", //accountid->账号
        views: {
          "main@front.editctr": {
            templateUrl: "./editingCenter/baijiahao/toBeCompiled/main.html",
            controller: "EditBaijiahaoToBeCompiledCtrl"
          }
        }
      })
      .state("baijiahaovideo", {
        url:
          "/baijiahaovideo?baijiahaoaccount&baijiahaoarticleid&isOriginal&baijiahaoplatform&iwometadataid&isawaitrevise",
        views: {
          "": {
            templateUrl:
              "./editingCenter/baijiahao/toBeCompiled/video/baijiahao_video.html",
            controller: "editingCenterBaijiahaoVideoCtrl"
          }
        }
      })
      .state("baijiahaonews", {
        url:
          "/baijiahaonews?baijiahaoaccount&baijiahaoarticleid&isOriginal&baijiahaoplatform&iwometadataid&isawaitrevise",
        views: {
          "": {
            templateUrl:
              "./editingCenter/baijiahao/toBeCompiled/news/baijiahao_news.html",
            controller: "editingCenterBaijiahaoNewsCtrl"
          }
        }
      })
      .state("baijiahaoatlas", {
        url:
          "/baijiahaoatlas?baijiahaoaccount&baijiahaoarticleid&isOriginal&baijiahaoplatform&iwometadataid&isawaitrevise",
        views: {
          "": {
            templateUrl:
              "./editingCenter/baijiahao/toBeCompiled/atlas/baijiahao_atlas.html",
            controller: "editingCenterBaijiahaoAtlasCtrl"
          }
        }
      });
  }
]);
